import { Component } from '@angular/core';

@Component({
    selector: 'order-return-bank-confirmmation',
    templateUrl: './order-return-bank-confirmation.html',
})
export class OrderReturnBankConfirmationComponent {}
